<template>
    <form 
    @submit="onSubmit"
    class="login_form"
    >
    <label for="email" class="login_label>">email</label>
    <input id="email"
    v-model="email"
    type="email"
    required
    >
    <label for="passwd" class="login_label>">пароль</label>
    <input id="passwd"
    v-model="password"
    type="password"
    required
    >
    <button type="submit" class="login_button">Войти</button>
    </form>
  </template>
  
  
  <script>
  import router from '@/router';
import { makeLogIn } from '../hub/auth'
  export default {
    name: 'LoginPage',
    props: {
      msg: String
    },
    data(){
      return{
        email: '',
        password: '',
      };
    },
    methods: {
      async onSubmit(){
        var data = await makeLogIn(this.email, this.password)
        if(data){
          localStorage.setItem('ArgoToken', 'Bearer ' + data)
          localStorage.setItem('ArgoUserEmail', this.email)
          router.push({name: 'hub'})
        }
      }
    },
    created(){
      var token = localStorage.getItem('ArgoToken')
      if(token){
        router.push({name: 'hub'})
      }
    }
  }
  </script>